export enum OrderType {
   homeDelivery = 'home-delivery',
   pickup = 'pickup',
}

export const SKELETON_LOADING = 'skeletonLoading';
